export default __webpack_public_path__ + "static/media/picture.f7a416ce.svg";